import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  ShoppingCart,
  Star,
  Search,
  Filter,
  AlertCircle,
  Heart,
  Share2,
  Grid,
  List,
  ChevronRight,
  ArrowUpCircle,
  Bell,
  Timer,
  TrendingUp,
  Tag,
  Truck,
  Shield,
  RefreshCw,
  Award,
} from "lucide-react";
import { API_URL, API_URL_UPLOADS, API_URL_STORE } from "./config";
import visa from "../assets/visa.png";
import mastercard from "../assets/mastercard.png";
import TrendingItems from "../components/trending";
import ImageCaresol from "../components/hero";
import ServiceBarge from "../components/ServicesBarge";

const Home = () => {
  const navigate = useNavigate();
  const [showCart, setShowCart] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cart, setCart] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [user, setUser] = useState(null);
  const [wishlist, setWishlist] = useState([]);
  const [viewMode, setViewMode] = useState("grid");
  const [sortBy, setSortBy] = useState("");
  const [priceRange, setPriceRange] = useState({ min: 0, max: 1000 });
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [loading, setLoading] = useState(true);
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [filters, setFilters] = useState({
    price: { min: 0, max: 1000 },
    rating: 0,
    availability: "all",
    brand: "all",
  });



  const userDetails = localStorage.getItem("user");
  console.log("User Details:", userDetails);

  useEffect(() => {
    fetchData();
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    setShowScrollTop(window.pageYOffset > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL_STORE}/productdefinition/full_products_definations`
      );
      const data = await response.json();
      setAllProducts(data);
      const uniqueCategories = [
        ...new Set(data.map((product) => product.category)),
      ];
      setCategories(uniqueCategories);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find(
        (item) => item.product_id === product.product_id
      );
      if (existing) {
        return prev.map((item) =>
          item.product_id === product.product_id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });

    // Show notification
    addNotification(`${product.product_name} added to cart`);
  };

  const toggleWishlist = (productId) => {
    setWishlist((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const addNotification = (message) => {
    const newNotification = {
      id: Date.now(),
      message,
      time: new Date().toLocaleTimeString(),
    };
    setNotifications((prev) => [newNotification, ...prev]);
  };

  const handleShare = (product) => {
    if (navigator.share) {
      navigator.share({
        title: product.product_name,
        text: product.description_notes,
        url: window.location.href,
      });
    }
  };

  const sortProducts = (products) => {
    switch (sortBy) {
      case "price-asc":
        return [...products].sort((a, b) => a.selling_price - b.selling_price);
      case "price-desc":
        return [...products].sort((a, b) => b.selling_price - a.selling_price);
      case "name":
        return [...products].sort((a, b) =>
          a.product_name.localeCompare(b.product_name)
        );
      case "rating":
        return [...products].sort((a, b) => (b.rating || 0) - (a.rating || 0));
      default:
        return products;
    }
  };

  const filteredProducts = allProducts.filter((product) => {
    const matchesCategory =
      !selectedCategory || product.category === selectedCategory;
    const matchesSubCategory =
      !selectedSubCategory || product.sub_category === selectedSubCategory;
    const matchesSearch = product.product_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesPrice =
      product.selling_price >= filters.price.min &&
      product.selling_price <= filters.price.max;
    const matchesRating = product.rating >= filters.rating;

    return (
      matchesCategory &&
      matchesSubCategory &&
      matchesSearch &&
      matchesPrice &&
      matchesRating
    );
  });

  const sortedProducts = sortProducts(filteredProducts);

  const totalAmount = cart.reduce(
    (total, item) => total + item.selling_price * item.quantity,
    0
  );

  // Featured Products Section
const FeaturedProducts = () => (
  <div className="container mb-5">
    <h3 className="mb-4">Featured Products</h3>
    <div className="row g-4">
      {sortedProducts.slice(0, 4).map((product) => (
        <div key={product.product_id} className="col-md-3">
          <div className="h-100 border-0">
            <div
              className="position-relative"
              style={{ marginBottom: 10 }}
            >
              <img
                className="card-img-top"
                src={`${API_URL_UPLOADS}/${product.uploaded_product_image_ref}`}
                alt={product.product_name}
                style={{
                  height: "150px", 
                    width: "100%",
                    objectFit: "contain",
                }}
              />
            </div>
            <div className="card-body px-4">
              <h6 className="card-title mb-1">{product.product_name}</h6>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-bold">${product.selling_price}</span>
                <div className="d-flex align-items-center">
                  {[...Array(5)].map((_, index) => (
                    <Star
                      key={index}
                      size={16}
                      fill={index < (product.rating || 0) ? "#ffc000" : "none"}
                      stroke={index < (product.rating || 0) ? "#ffc000" : "#6c757d"}
                    />
                  ))}
                </div>
              </div>
              {/* Removed Add to Cart button */}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);



  return (
    <div className="min-vh-100 bg-light" style={{ marginTop: 40 }}>
      {/* Navigation Bar */}
      <nav
        className="navbar navbar-expand-lg fixed-top py-10 shadow-sm"
        style={{ backgroundColor: "#ffc000", marginBottom: 20}}
      >
        {/* ... (previous navbar code) ... */}
        <div className="container">
          <Link className="navbar-brand fw-bold text-dark" to="/">
            XGO Marketplace
          </Link>
          <div className="d-flex align-items-center gap-3">
         <button
    className="btn position-relative"
    onClick={() => {
      setShowNotifications(!showNotifications);
      navigate('/OrderHistory'); 
    }}
  >
    <Timer />
    {notifications.length > 0 && (
      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        {notifications.length}
      </span>
    )}
  </button>

            <button
              className="btn position-relative"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <Bell />
              {notifications.length > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {notifications.length}
                </span>
              )}
            </button>
            {user ? (
              <div className="text-dark me-3 text-end">
                <div className="fw-bold">{user.username}</div>
                <div style={{ fontSize: "0.85rem" }}>{user.email}</div>
              </div>
            ) : (
              <>
                <Link to="/login">
                  <button className="btn btn-outline-dark">Sign In</button>
                </Link>
                <Link to="/TermsCondition">
                  <button className="btn btn-dark">Sign Up</button>
                </Link>
              </>
            )}
            <button
              className="btn position-relative"
              onClick={() => navigate("/cart", { state: { cart } })}
            >
              <ShoppingCart />
              {cart.length > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {cart.reduce((sum, item) => sum + item.quantity, 0)}
                </span>
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Search and Filters */}
      <div className="container mb-4" style={{ paddingTop: 50 }}>
        <div className="row g-3">
          <div className="col-md-8">
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="btn btn-dark">
                <Search size={20} />
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-dark flex-grow-1"
                onClick={() => setShowFilters(!showFilters)}
              >
                <Filter className="me-2" />
                Filters
              </button>
              <button
                className="btn btn-outline-dark"
                onClick={() =>
                  setViewMode(viewMode === "grid" ? "list" : "grid")
                }
              >
                {viewMode === "grid" ? <List /> : <Grid />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Panel */}
      {showFilters && (
        <div className="container mb-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">Price Range</label>
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Min"
                      value={filters.price.min}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          price: {
                            ...filters.price,
                            min: Number(e.target.value),
                          },
                        })
                      }
                    />
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Max"
                      value={filters.price.max}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          price: {
                            ...filters.price,
                            max: Number(e.target.value),
                          },
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Rating</label>
                  <select
                    className="form-select"
                    value={filters.rating}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        rating: Number(e.target.value),
                      })
                    }
                  >
                    <option value="0">All Ratings</option>
                    <option value="4">4+ Stars</option>
                    <option value="3">3+ Stars</option>
                    <option value="2">2+ Stars</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Sort By</label>
                  <select
                    className="form-select"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="">Featured</option>
                    <option value="price-asc">Price: Low to High</option>
                    <option value="price-desc">Price: High to Low</option>
                    <option value="name">Name</option>
                    <option value="rating">Rating</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Availability</label>
                  <select
                    className="form-select"
                    value={filters.availability}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        availability: e.target.value,
                      })
                    }
                  >
                    <option value="all">All</option>
                    <option value="in-stock">In Stock</option>
                    <option value="out-of-stock">Out of Stock</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section with Carousel */}
      <ImageCaresol />

      {/* Features Section */}
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="d-flex align-items-center">
              <Truck className="me-3" size={24} style={{ color: "#ffc000" }} />
              <div>
                <h6 className="mb-1">XGo Reliable Shipping</h6>
                <p className="small text-muted mb-0">Reliable delivery with XGo</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex align-items-center">
              <Shield className="me-3" size={24} style={{ color: "#ffc000" }} />
              <div>
                <h6 className="mb-1">Secure Payment</h6>
                <p className="small text-muted mb-0">100% secure payment</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex align-items-center">
              <RefreshCw
                className="me-3"
                size={24}
                style={{ color: "#ffc000" }}
              />
              <div>
                <h6 className="mb-1">Easy Returns</h6>
                <p className="small text-muted mb-0">5 day return policy</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex align-items-center">
              <Award className="me-3" size={24} style={{ color: "#ffc000" }} />
              <div>
                <h6 className="mb-1">Quality Products</h6>
                <p className="small text-muted mb-0">Certified products</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products */}
      <FeaturedProducts />

      {/* Featured Products */}
      <ServiceBarge />

      {/* Main Products Display */}
     <div className="container mb-5">
  {loading ? (
    <div className="text-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <>
      {/* Display main category once */}
      <h4>{sortedProducts[0]?.category}</h4>

      {/* Subcategory display */}
 <div className="d-flex mb-2 overflow-auto flex-wrap">
  {sortedProducts
    .filter((product, index, self) =>
      index === self.findIndex((p) => p.sub_category === product.sub_category)
    )
    .map((product) => (
      <span 
        key={product.product_id} 
        className="me-2 mb-1" 
        style={{
          padding: '2px 8px', 
          borderWidth: 1,
          borderColor: "#000",
          borderRadius: '2px',
          whiteSpace: 'nowrap',
          marginBottom: 5
        }}
      >
        {product.sub_category}
      </span>
    ))}
</div>


      <div className={viewMode === "grid" ? "row row-cols-1 row-cols-md-4 g-4" : ""}>
        {sortedProducts.length === 0 ? (
          <div className="text-center py-5">
            <AlertCircle size={48} className="text-muted mb-3" />
            <h4>No Products Found</h4>
            <p>Please adjust your search or filter criteria.</p>
          </div>
        ) : (
          sortedProducts.map((product) => (
            <div key={product.product_id} className={viewMode === "grid" ? "col" : "mb-3"}>
              <div className={`h-100 ${viewMode === "list" ? "flex-row" : ""}`}>
                <img
                  className={`card-img-${viewMode === "list" ? "left" : "top"}`}
                  src={`${API_URL_UPLOADS}/${product.uploaded_product_image_ref}`}
                  alt={product.product_name}
                  style={{
                    height: "150px", 
                    width: "100%",
                    objectFit: "contain",
                  }}
                  onClick={() => {
                    setSelectedProduct(product);
                    setShowProductModal(true);
                  }}
                />
                <div className="card-body">
                  <h5 className="card-title mb-1">{product.product_name}</h5>
                  <p className="text-muted small mb-2">{product.category}</p>
                  <span className="fw-bold">${product.selling_price}</span>

                  <div className="d-flex gap-2 mt-2">
                    <button
                      style={{ color: "#fff" }}
                      className="btn btn-warning flex-grow-1"
                      onClick={() => addToCart(product)}
                    >
                      Add to Cart
                    </button>
                  </div>
                  
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  )}
</div>



      {/* Notifications Panel */}
      {showNotifications && (
        <div
          className="position-fixed top-0 end-0 p-3"
          style={{ zIndex: 1050, marginTop: "56px" }}
        >
          <div className="card shadow" style={{ width: "300px" }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Notifications</h6>
              <button
                className="btn-close"
                onClick={() => setShowNotifications(false)}
              ></button>
            </div>
            <div
              className="card-body"
              style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              {notifications.length === 0 ? (
                <p className="text-muted text-center mb-0">No notifications</p>
              ) : (
                notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className="d-flex align-items-center mb-3"
                  >
                    <div className="me-3">
                      <Bell size={20} className="text-primary" />
                    </div>
                    <div>
                      <p className="mb-0">{notification.message}</p>
                      <small className="text-muted">{notification.time}</small>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          className="btn position-fixed bottom-0 end-0 m-3 rounded-circle"
          onClick={scrollToTop}
          style={{ zIndex: 1000, color: "#fcc000" }}
        >
          <ArrowUpCircle />
        </button>
      )}

      {/* Product Modal */}
      {showProductModal && selectedProduct && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedProduct.product_name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProductModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <img
                      src={`${API_URL_UPLOADS}/${selectedProduct.uploaded_product_image_ref}`}
                      alt={selectedProduct.product_name}
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="col-md-6">
                    <h4 className="mb-3">${selectedProduct.selling_price}</h4>
                    <div className="d-flex align-items-center mb-3">
                      {[...Array(5)].map((_, index) => (
                        <Star
                          key={index}
                          size={20}
                          fill={
                            index < (selectedProduct.rating || 0)
                              ? "#ffc000"
                              : "none"
                          }
                          stroke={
                            index < (selectedProduct.rating || 0)
                              ? "#ffc000"
                              : "#6c757d"
                          }
                        />
                      ))}
                      <span className="ms-2">{selectedProduct.rating}</span>
                    </div>
                    <p>{selectedProduct.description_notes}</p>
                    <div className="d-flex gap-2 mb-3">
                      <button
                        className="btn btn-warning flex-grow-1"
                        onClick={() => {
                          addToCart(selectedProduct);
                          setShowProductModal(false);
                        }}
                      >
                        Add to Cart
                      </button>
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() =>
                          toggleWishlist(selectedProduct.product_id)
                        }
                      >
                        <Heart
                          fill={
                            wishlist.includes(selectedProduct.product_id)
                              ? "red"
                              : "none"
                          }
                        />
                      </button>
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => handleShare(selectedProduct)}
                      >
                        <Share2 />
                      </button>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <h6>Product Details</h6>
                        <ul className="list-unstyled mb-0">
                          <li>Category: {selectedProduct.category}</li>
                          <li>Sub Category: {selectedProduct.sub_category}</li>
                          {/* Add more product details */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* advert */}
      <div
        id="heroCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ marginTop: "56px", marginBottom: 40 }}
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div
              className=" text-black py-5"
              style={{ backgroundColor: "gray" }}
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <h1 className="display-4 fw-bold mb-4">
                      Discover Amazing Products
                    </h1>
                    <p className="lead mb-4">
                      Your one-stop shop for software licenses and gas solutions
                    </p>
                    <button className="btn btn-warning btn-lg" style={{color: 'white'}}>Shop Now</button>
                  </div>
                  <div className="col-md-6">{/* Add hero image here */}</div>
                </div>
              </div>
            </div>
          </div>
          {/* Add more carousel items */}
        </div>
      </div>

      {/* Treanding */}
      <TrendingItems />

      {/* Footer */}
      <footer className="bg-dark text-white py-5 mt-auto">
        <style>
          {`
      .text-white a {
        text-decoration: none;
      }
      .text-white a:hover {
        text-decoration: underline; /* Optional: add underline on hover */
      }
    `}
        </style>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-4">
              <h5>About XGO Marketplace</h5>
              <p className="small">
                Your trusted destination for quality products
              </p>
              <div className="d-flex gap-3">{/* Add social media icons */}</div>
            </div>
            <div className="col-md-2">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="#" className="text-white">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white">
                    Contact
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/FAQs" className="text-white">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="/DataPrivacyPolicy" className="text-white">
                    Data Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/ReturnRefundPolicy" className="text-white">
                    Return and Refund Policy
                  </a>
                </li>
                <li>
                  <a href="/PackageSendingProcedures" className="text-white">
                    Package Sending Rules
                  </a>
                </li>
                <li>
                  <a href="/PackageSendingProcedures" className="text-white">
                    Shopping Online Procedure
                  </a>
                </li>
                <li>
                  <a href="/CourierDriverRules" className="text-white">
                    Courrier Driver Rules
                  </a>
                </li>
                <li>
                  <a href="/CustomerParcelPickupDrop" className="text-white">
                    Customer Parcel Pickup and Drop
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <h5>Categories</h5>
              <ul className="list-unstyled">
                {categories.slice(0, 4).map((category) => (
                  <li key={category}>
                    <a href="#" className="text-white">
                      {category}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-4">
              <h5>Newsletter</h5>
              <p className="small">
                Subscribe to get updates on new products and special offers
              </p>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                />
                <button className="btn btn-warning" type="button">
                  Subscribe
                </button>
              </div>
              <div className="d-flex gap-2">
                <img style={{height: 40}} src={visa} alt="Visa"  />
                <img style={{height: 40}} src={mastercard} alt="Mastercard" />
              </div>
            </div>
          </div>
          <hr className="my-4" />
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="small mb-0">
                © 2025 XGO Marketplace. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <a href="/TermsOfUse" className="text-white small me-3">
                Terms of Use
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
